export const CREATE_ASSOCIATION_FORM_ID = 'create-association-form';
